import { css } from 'emotion';

const failedPaymentStyles = css`
	margin-bottom: 16px;
	&:last-child {
		margin-bottom: 0;
	}
	.c-m-payment-review--has-status {
		&:before {
			background: #39aeff;
		}
		.c-o-submitted-transaction-table--warning & {
			&:before {
				background: #39aeff;
			}
		}
	}
	.c-m-payment-review--status-obligate {
		&:before {
			background: #39aeff;
		}
	}
	.c-m-payment-review__status--failed {
		max-width: 400px;
	}
	.c-m-payment-review__status-label svg {
		fill: #f00;
	}
	.c-m-payment-review__status-title {
		color: #f00;
	}
	@media (min-width: 600px) {
		.c-m-payment-review__status--failed {
			max-width: 100%;
			position: static;
			text-align: left;
			.c-m-payment-review__status-label {
				flex-basis: 80px;
				justify-content: flex-end;
				padding-right: 16px;
			}
			.c-m-payment-review__status-value {
				flex: 3;
			}
		}
	}
	@media (min-width: 840px) {
		.c-m-payment-review__status--failed {
			max-width: 400px;
			position: absolute;
			text-align: right;
			.c-m-payment-review__status-label {
				flex-basis: 100%;
				justify-content: flex-end;
				padding-right: 0;
			}
			.c-m-payment-review__status-value {
				flex: auto;
			}
		}
	}
	@media (min-width: 1280px) {
		.c-m-payment-review__status--failed {
			position: static;
		}
		.c-m-payment-review__status-label {
			margin-bottom: 12px;
			order: 0;
		}
	}
`;

const obligatePaymentStyles = css`
	.c-m-payment-review--has-status {
		&:before {
			background: #39aeff;
		}
		.c-o-submitted-transaction-table--warning & {
			&:before {
				background: #39aeff;
			}
		}
	}
`;

export { failedPaymentStyles, obligatePaymentStyles };
